'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002474 from "./presto.-Two-Factor-Auth-View$$anon$74.js";
import * as $j_presto$002etypes$0024$0024anon$00244 from "./presto.types$$anon$4.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dId$0024 from "./presto.types$-Credential-Id$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024 from "./presto.types$-Credential-Kind$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024 from "./presto.types$-Credential-Name$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024 from "./presto.types$-Credential-Username$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$73() {
  this.bH9 = null;
  this.bH1 = null;
  this.bH2 = false;
  this.bHa = null;
  this.bHb = false;
  this.bHe = null;
  this.bH7 = null;
  this.bH8 = false;
  this.bH3 = null;
  this.bH4 = false;
  this.bH5 = null;
  this.bH6 = false;
  this.bHc = false;
  this.bHd = false;
  this.bH9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bHe = "Credential";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$73 as $c_Lpresto_TwoFactorAuthView$$anon$73 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$73.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$73;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$73() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$73 as $h_Lpresto_TwoFactorAuthView$$anon$73 };
$h_Lpresto_TwoFactorAuthView$$anon$73.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bH9;
});
$p.L = (function() {
  if ((!this.bH2)) {
    this.bH1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bH2 = true;
  }
  return this.bH1;
});
$p.O = (function() {
  if ((!this.bHb)) {
    this.bHa = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bHb = true;
  }
  return this.bHa;
});
$p.E = (function() {
  return this.bHe;
});
$p.t = (function() {
  if ((!this.bH8)) {
    this.bH7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("username", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("inherited", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bH8 = true;
  }
  return this.bH7;
});
$p.M = (function() {
  if ((!this.bH4)) {
    this.bH3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dId$0024.$m_Lpresto_types$CredentialId$().gH(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dKind$0024.$m_Lpresto_types$CredentialKind$().cx(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dName$0024.$m_Lpresto_types$CredentialName$().gl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dUsername$0024.$m_Lpresto_types$CredentialUsername$().gI(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().ep(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bH4 = true;
  }
  return this.bH3;
});
$p.Q = (function() {
  if ((!this.bH6)) {
    this.bH5 = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002474.$c_Lpresto_TwoFactorAuthView$$anon$74();
    this.bH6 = true;
  }
  return this.bH5;
});
$p.w = (function() {
  if ((!this.bHd)) {
    this.bHc = false;
    this.bHd = true;
  }
  return this.bHc;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee796) => ((p) => \u03b4scrutinee796.gj(p)))($j_presto$002etypes$0024$0024anon$00244.$m_Lpresto_types$Credential$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$73 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$73, "presto.TwoFactorAuthView$$anon$73", ({
  Td: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$73 as $d_Lpresto_TwoFactorAuthView$$anon$73 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$73.js.map
